export const imagesToBase64Array = async (images: (File | null)[]) => {
  const promises = images.map(async (file, index) => {
    if (!file) return null
    const base64 = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result as string)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })

    return {
      name: `image_${index + 1}.${file.name.split('.').pop()}`,
      content: base64
    }
  })

  const base64Images = await Promise.all(promises)
  return base64Images.filter((img): img is { name: string, content: string } => img !== null)
}
